import { axios } from '@/utils/request'

const api = {
  enterprise: '/system/user'
}

export function findByDeptId (parameter) {
  return axios({
    url: api.enterprise + '/findByDeptId/' + parameter,
    method: 'get'
  })
}